import { round } from "commons/src/helpers/RoundingHelpers";

export const percentageTo2DecimalPlaces = percentage => {
    const minimumDisplayPercentage = 0.01;
    if ((percentage && typeof percentage === "number") || percentage === 0) {
        return percentage < minimumDisplayPercentage ? "< 0.01%" : `${percentage.toFixed(2)}%`;
    }
    return "N/A";
};

export function formatFloat(value) {
    return value || value === 0 ? round(value, 2).toString() : "";
}

export function formatToPositive(value) {
    return value || value === 0 ? Math.abs(round(value, 2)).toString() : "";
}

export function isTextValidForNumericInput(input) {
    return /^-?\d*\.?\d*$/.test(input);
}

export function isTextValidForWholeNumberInput(input) {
    return /^\d*$/.test(input);
}

export const getFullClientName = client =>
    client.forename ? `${client.forename} ${client.surname}` : `${client.surname}`;

export const getClientDisplayName = ({ clientId, forename, surname }) =>
    `${getFullClientName({ forename, surname })} ${clientId}`;

export const getLocationDisplayName = location =>
    location ? `${location?.name} ${location?.locationId}` : "";
